// extracted by mini-css-extract-plugin
export default {"altButton":"Kt24jyp_"};